// This file was automatically generated from appchart.dialog.ordermed.selectThread.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.ordermed.selectThread');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.model.medOrderThread');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.ordermed.selectThread.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div id="select-thread-container" class="overlayContainer"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.ordermed.selectThread.allLists = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.appchart.dialog.ordermed.selectThread.list({threads: opt_data.permRx, str: 'Permanent Rx'}, output);
  el8.template.appchart.dialog.ordermed.selectThread.list({threads: opt_data.permOtc, str: 'Permanent OTC'}, output);
  el8.template.appchart.dialog.ordermed.selectThread.list({threads: opt_data.temp, str: 'Temporary'}, output);
  el8.template.appchart.dialog.ordermed.selectThread.list({threads: opt_data.dc, str: 'Discontinued'}, output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.ordermed.selectThread.list = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<h4 class="el8SectionHeaderNoCollapse">', soy.$$escapeHtml(opt_data.str), '</h4>');
  if (opt_data.threads.length > 0) {
    output.append('<ol>');
    var tList2027 = opt_data.threads;
    var tListLen2027 = tList2027.length;
    for (var tIndex2027 = 0; tIndex2027 < tListLen2027; tIndex2027++) {
      var tData2027 = tList2027[tIndex2027];
      output.append('<li class="el8MedsListItem el8ItemHover select-thread-trigger" data-id="', soy.$$escapeHtml(tData2027.id), '"><span class="el8CheckboxWrapPosition"><input type="checkbox" /></span>', (soy.$$escapeHtml(tData2027.startDate)? el8.service.tz.soyShortDate(soy.$$escapeHtml(tData2027.startDate)) : ''), ' ');
      el8.template.ptdata.model.medOrderThread.summary(tData2027, output);
      output.append('</li>');
    }
    output.append('</ol><div class="spacer"></div>');
  } else {
    output.append('<p class="el8FeedEmpty">No medications</p>');
  }
  if (!opt_sb) return output.toString();
};
